import React, { useEffect } from "react";

import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import { connect } from "react-redux";
import { ApplicationState } from "../../../redux/reducers";
import { logout } from "../../../redux/auth/creators";
import { addToast } from "../../../redux/ui/creators";
import { useHistory } from "react-router-dom";

import Arrow from "../../../assets/images/arrow.svg";
import Logo from "../../../assets/images/Logo.png";
import UserLogo from "../../../assets/images/login.svg";
import LogOut from "../../../assets/images/log-out.svg";
import LinkIcon from "../../../assets/images/link.svg";

import { useTranslation } from "react-i18next";

import "./style.scss";
import Translate from "../../../i18n/translationComponent";
import { FormControl, InputLabel, Select } from "@material-ui/core";
import getConfig from "../../../aws-config";

const appbarTheme = createTheme({
	palette: {
		primary: {
			main: "#fff",
		},
	},
});

interface StateProps {
	user: any;
}
interface RequiredProps {
	children?: JSX.Element;
}
interface OptionalProps {
	logout: any;
	isIssuer: any;
}
type Props = StateProps & RequiredProps & OptionalProps;

const MenuAppBar = (props: Props) => {
	const [auth] = React.useState(true);
	const [onBehalfOf, setOnBehalfOf] = React.useState("");
	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);
	let history = useHistory();
	const { t, i18n } = useTranslation();
	// const availableLanguages = Object.keys(i18n.services.resourceStore.data);
	const availableLanguages: any = {
		en: "EN",
		//ro: "Română",
		de: "DE",
		it: "IT",
		fr: "FR",
		es: "ES",
		pt: "PT",
	};

	//all available languages to be made into a selector for the user

	const changeLanguageHandler = (lang: any) => {
		i18n.changeLanguage(lang);
	};

	useEffect(() => {
		const lsItem = localStorage.getItem("onBehalfOf");

		// change active language for i18n
		// setTimeout(() => {
		// 	changeLanguageHandler("en");
		// }, 4000);

		if (lsItem && lsItem != "null") {
			setOnBehalfOf(lsItem);
		}
	});
	const handleLanguageSelect = (event: any) => {
		changeLanguageHandler(event.target.value);
	};
	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleLogout = () => {
		props.logout().then(() => {
			localStorage.removeItem("jwt");
			localStorage.removeItem("IdToken");
			localStorage.removeItem("onBehalfOf");
			history.push("/login");
		});
	};

	const navigateDashboard = () => {
		history.push("/dashboard");
	};
	// const navigateCommunications = () => {
	// 	history.push("/communications");
	// };
	const navigateAccount = () => {
		history.push("/my-account");
	};
	const allowsLanguageChange = () => {
		const allowedEmails = [""];
		return allowedEmails.includes(props.user.attributes.email) || props.user.attributes.email.includes("");
	};
	const openIssuersApp = () => {
		let link = document.createElement("a");
		const config = getConfig();

		link.setAttribute("href", config.issuer_app_url);
		link.setAttribute("target", "_blank");
		document.body.appendChild(link); // Required for FF

		link.click();
	};

	return (
		<div className="root appBarBand">
			<Container>
				<ThemeProvider theme={appbarTheme}>
					<AppBar position="static" className="appbar">
						<Toolbar className="topBar">
							<div className="topBarMenu">
								<div className="logo">
									<a href="https://gutenbergcerts.com">
										<img src={Logo} alt="gutenberg cert logo" className="CertLogo" />
									</a>
									&nbsp;&nbsp;
								</div>
								<div className="navTopMenu">
									<a className="navDashboard" onClick={navigateDashboard}>
										<Translate text="Credentials" />
									</a>
									{/* {props.user.attributes.email.includes("@gutenbergcerts.com") && (
										<a className="navDashboard" onClick={navigateCommunications}>
											<Translate text="Inbox" />
										</a>
									)} */}
								</div>
							</div>
							{auth && (
								<div style={{ display: "flex" }}>
									<section className="menuRight" aria-controls="menu-appbar" onClick={handleClick}>
										<img src={Arrow} alt="down arrow" className={open ? "arrowDown" : "arrowUp"}></img>
										<Typography gutterBottom variant="inherit" component="p" className="userName">
											{props.user && props.user.attributes.email}
										</Typography>
										<img src={UserLogo} alt="user logo" className="userLogo"></img>
									</section>
									<Menu
										id="menu-appbar"
										className="menuApp"
										anchorOrigin={{
											vertical: "top",
											horizontal: "right",
										}}
										transformOrigin={{ vertical: "top", horizontal: "right" }}
										anchorEl={anchorEl}
										keepMounted
										open={open}
										onClose={handleClose}
									>
										{/* <MenuItem className='menuItem' onClick={createCertificates}>Issue Certificates</MenuItem>
                    <MenuItem className='menuItem' onClick={manageTemplates}>Certificate Templates</MenuItem>
                    <MenuItem className='menuItem' onClick={navigateZoom}>Zoom Meetings</MenuItem>
                    <MenuItem className='menuItem' onClick={navigateIssuedCertificates}>View Certificates</MenuItem> */}
										{/* <MenuItem className='menuItem' onClick={navigateAccount}>Manage Account</MenuItem> */}
										{props.isIssuer && (
											<MenuItem className="menuItem" onClick={openIssuersApp}>
												<img src={LinkIcon} alt="" className="logoutIcon"></img>

												<Translate text="Open Issuers App"></Translate>
											</MenuItem>
										)}
										<MenuItem className="menuItem" onClick={handleLogout}>
											<img src={LogOut} alt="" className="logoutIcon"></img>
											<Translate text="Logout" />
										</MenuItem>
									</Menu>

									<Select labelId="language-selector" onChange={handleLanguageSelect} value={i18n.language}>
										{Object.keys(availableLanguages).map((language: string) => {
											if (language == "de" || language == "ro" || language == "en") {
												return (
													<MenuItem key={language} value={language}>
														{availableLanguages[language]}
													</MenuItem>
												);
											} else {
												if (allowsLanguageChange())
													return (
														<MenuItem key={language} value={language}>
															{availableLanguages[language]}
														</MenuItem>
													);
											}
										})}
									</Select>
								</div>
							)}
						</Toolbar>
					</AppBar>
					<AppBar position="static" className="appbar mobile">
						<Toolbar className="topBar">
							<div className="mobile-links">
								<a className="navDashboard" onClick={navigateDashboard}>
									Credentials
								</a>
								{/* {props.user.attributes.email.includes("@gutenbergcerts.com") && (
									<a className="navDashboard" onClick={navigateCommunications}>
										Inbox
									</a>
								)} */}
							</div>
						</Toolbar>
					</AppBar>
				</ThemeProvider>
			</Container>
		</div>
	);
};

export default connect<any, any, any>(
	(state: ApplicationState | any) => {
		return {
			user: state.auth.user,
		};
	},
	(dispatch: any) => {
		return {
			logout: dispatch(logout),
		};
	}
)(MenuAppBar);
